/* eslint-disable */
export default [
  {
    path: "/serial-sim-ra-so-tb",
    name: "MsisdnFromMsin",
    component: () => import(/* webpackChunkName: "crm" */ "@/views/crm/MsisdnFromMsin.vue"),
    meta: {
      pageTitle: "Tra cứu serial sim ra số thuê bao",
      breadcrumb: [
        {
          text: "CRM"
        },
        {
          text: "Pack 1",
          active: true
        }
      ]
    }
  },
  {
    path: "/tra-cuu-tai-khoan",
    name: "getBalance",
    component: () => import(/* webpackChunkName: "crm" */ "@/views/crm/getBalance.vue"),
    meta: {
      pageTitle: "Tra cứu tài khoản",
      breadcrumb: [
        {
          text: "CRM"
        },
        {
          text: "Pack 1",
          active: true
        }
      ]
    }
  },
  {
    path: "/cdr-detail",
    name: "getCDRDetail",
    component: () => import(/* webpackChunkName: "crm" */ "@/views/crm/getCDRDetail.vue"),
    meta: {
      pageTitle: "Lịch sử gọi và tin nhắn",
      breadcrumb: [
        {
          text: "CRM"
        },
        {
          text: "Pack 1",
          active: true
        }
      ]
    }
  },
  {
    path: "/trang-thai-phe-duyet",
    name: "ApprovalStatus",
    component: () => import(/* webpackChunkName: "crm" */ "@/views/crm/ApprovalStatus.vue"),
    meta: {
      pageTitle: "Trạng thái phê duyệt",
      breadcrumb: [
        {
          text: "CRM"
        },
        {
          text: "Pack 1",
          active: true
        }
      ]
    }
  },
  {
    path: "/thu-hoi-so",
    name: "fileList",
    component: () => import(/* webpackChunkName: "crm" */ "@/views/crm/fileList.vue"),
    meta: {
      pageTitle: "Thu hồi số",
      breadcrumb: [
        {
          text: "CRM"
        },
        {
          text: "Pack 1",
          active: true
        }
      ]
    }
  },
  {
    path: "/danh-sach-doi-tac",
    name: "PartnerList",
    component: () => import(/* webpackChunkName: "crm" */ "@/views/crm/PartnerList.vue"),
    meta: {
      pageTitle: "Danh sách đối tác",
      breadcrumb: [
        {
          text: "CRM"
        },
        {
          text: "Danh sách đối tác",
          active: true
        }
      ]
    }
  },
  {
    path: "/mua-lai-sim",
    name: "BuyBackSim",
    component: () => import(/* webpackChunkName: "crm" */ "@/views/MuaLaiSim/MuaLaiSim.vue"),
    meta: {
      pageTitle: "Mua lại sim",
      breadcrumb: [
        {
          text: "CRM"
        },
        {
          text: "Mua lại sim",
          active: true
        }
      ]
    }
  },
  {
    path: "/video-call",
    name: "videoCall",
    component: () => import(/* webpackChunkName: "videoCall" */ "@/views/videoCall/VideoCall.vue"),
    meta: {
      pageTitle: "Video Call",
      breadcrumb: [
        {
          text: "Video Call"
        }
      ]
    }
  },
  {
    path: "/videoCall/DKTT",
    name: "VideoCallDKTT",
    component: () => import(/* webpackChunkName: "videoCall" */ "@/views/videoCallQuanLy/VideoCallDKTT.vue"),
    meta: {
      breadcrumb: [
        {
          text: "Đăng ký thông tin"
        }
      ]
    }
  },
  {
    path: "/videoCall/QuanLyDTV",
    name: "QuanLyDTV",
    component: () => import(/* webpackChunkName: "videoCall" */ "@/views/videoCallQuanLy/QuanLyDTV.vue"),
    meta: {
      breadcrumb: [
        {
          text: "Quản lý ĐTV"
        }
      ]
    }
  },
  {
    path: "/videoCall/DSTB",
    name: "VideoCallDSTB",
    component: () => import(/* webpackChunkName: "videoCall" */ "@/views/videoCallQuanLy/VideoCallDSTB.vue"),
    meta: {
      breadcrumb: [
        {
          text: "DSTB"
        }
      ]
    }
  },
  {
    path: "/videoCall/DSTB_Busy",
    name: "VideoCallDSTBBUSY",
    component: () =>
        import(/* webpackChunkName: "videoCall" */ "@/views/videoCallQuanLy/VideoCallDSTBPheDuyet.vue"),
    meta: {
      breadcrumb: [
        {
          text: "DSTB Phê duyệt"
        }
      ]
    }
  },
  {
    path: "/videoCall/CNTT",
    name: "VideoCallCNTT",
    component: () => import(/* webpackChunkName: "videoCall" */ "@/views/videoCallQuanLy/VideoCallCNTT.vue"),
    meta: {
      breadcrumb: [
        {
          text: "Cập nhật thông tin"
        }
      ]
    }
  },
  {
    path: "/videoCall/KHDN",
    name: "VideoCallKHDN",
    component: () => import(/* webpackChunkName: "videoCall" */ "@/views/videoCallQuanLy/VideoCallKHDN.vue"),
    meta: {
      breadcrumb: [
        {
          text: "Khách hàng doanh nghiệp"
        }
      ]
    }
  },
  {
    path: "/zns/template",
    name: "ZnsTemplate",
    component: () => import(/* webpackChunkName: "zns" */ "@/views/zns/ZnsTemplate.vue"),
    meta: {
      pageTitle: "Quản lý Template ZNS",
      breadcrumb: [
        {
          text: "ZNS"
        },
        {
          text: "Quản lý Template",
          active: true
        }
      ]
    }
  },
  {
    path: "/zns/campaign",
    name: "ZnsCampaign",
    component: () => import(/* webpackChunkName: "zns" */ "@/views/zns/ZnsCampaign.vue"),
    meta: {
      pageTitle: "Gửi ZNS theo file",
      breadcrumb: [
        {
          text: "ZNS"
        },
        {
          text: "Gửi file ZNS",
          active: true
        }
      ]
    }
  }
];
